module.exports = "/remote-dist/eff37f9179cc2623b2bef0c1ff8bdfba.png";